'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@kiao-voice/ui-kit'
import type { LapsedTeamSummary } from '@kiao-voice/api-contract/organization'
import { WorkspacePageHeader } from '../../components/workspace-indicator'

export function LapsedTeamRecovery({ team, pricingReady, pricingError, onRetry, onSubscribe }: {
  team: LapsedTeamSummary
  pricingReady: boolean
  pricingError: boolean
  onRetry: () => void
  onSubscribe: () => void
}) {
  const { t } = useTranslation('web')
  const name = team.name.includes('@') ? t('team.untitledOrg') : team.name
  return (
    <>
      <WorkspacePageHeader title={t('team.lapsedHeading')} subtitle={t('team.lapsedBody')} />
      <section className="max-w-[480px]" data-testid="team-lapsed">
        <p className="text-sm text-muted">{t('team.lapsedRetained', { name, count: team.memberCount })}</p>
        <div className="mt-[var(--gap-md)]">
          <Button variant="primary" disabled={!pricingReady} onClick={onSubscribe} data-testid="team-lapsed-cta">
            {t('team.lapsedCta')}
          </Button>
        </div>
        {!pricingReady && <p className="note" role={pricingError ? 'alert' : 'status'}>
          {t(pricingError ? 'team.errGeneric' : 'team.processing')}
        </p>}
        {pricingError && <Button variant="secondary" onClick={onRetry} data-testid="team-lapsed-retry">
          {t('team.lapsedRetry')}
        </Button>}
      </section>
    </>
  )
}
